


























import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import VueI18n from "vue-i18n";

@Component({
  components: {},
})
export default class MySelect extends Vue {
  @Prop({ default: null }) value: any;
  @Prop({ default: false }) required: boolean;
  @Prop({ default: "" }) label: string | VueI18n.TranslateResult;
  @Prop({ default: false }) autoComplete : boolean;
  @Prop({ default: "" }) id?: string;

  get identifier() {
    return this.id ? this.id : this.lodash.uniqueId(`myselect-${new Date().getTime()}-`);
  }

  get selectedValue() {
    return this.value;
  }

  set selectedValue(value) {
    this.$emit("input", value);
  }
}
